// maintaining three separate maps for efficient lookup by both the
// product association ID, the flashcard ID, and the category ID
const state = () => ({
  productAssociations: {},
  productAssociationsByFlashcardId: {},
  productAssociationsByCategoryId: {},
});

const getters = {
  hasId: (state) => (id) => !!state.productAssociations[id],
  uniqueFlashcardIds: (state) => {
    return Object.keys(state.productAssociationsByFlashcardId);
  },
  flashcardCategories: (state) => (flashcardId) => {
    const associations = state.productAssociationsByFlashcardId[flashcardId] || [];
    return associations.map(association => association.categoryId).filter(id => id != null);
  },
  categoryFlashcards: (state) => (categoryId) => {
    const associations = state.productAssociationsByCategoryId[categoryId] || [];
    return associations.map(association => association.flashcardId).filter(id => id != null);
  },
};

const mutations = {
  set: (state, associations = []) => {
    const byId = {};
    const byFlashcardId = {};
    const byCategoryId = {};
    for (const association of associations) {
      byId[association.id] = association;
      if (association.flashcardId != null) {
        (byFlashcardId[association.flashcardId] ??= []).push(association);
      }
      if (association.categoryId != null) {
        (byCategoryId[association.categoryId] ??= []).push(association);
      }
    }
    state.productAssociations = byId;
    state.productAssociationsByFlashcardId = byFlashcardId;
    state.productAssociationsByCategoryId = byCategoryId;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
